import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PackageResponseInterface } from '../../../../interfaces/package-response.interface';
import { Presentacion } from '../../../../interfaces/presentation.interface';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { PresentationUtilsService } from '../../../services/presentation-utils.service';

@Component({
    selector: 'app-edit-presentation',
    templateUrl: './edit-presentation.component.html',
    styleUrls: ['./edit-presentation.component.css'],
})
export class EditPresentationComponent {
    presentationId: string;
    productId: string;
    currentPresentation: Presentacion;
    selectedUnity: number = null;

    optPackaging: any[] = [];
    currentPresentationNav: any;
    selectedTypeProduct = null;

    optUnitsOfMeasurement: any[] = [];
    quantity: number = null;
    quantityHolder: number = null;
    product: any;

    selectedEmpaque = 0;
    lastSelectedEmpaque: number = null;
    codeUnitMeasurement: string = null;

    private apiUrl: string = environment.apiSiriUrl;
    codigoSeleccionado: string;
    productTypeName: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private modalService: NgbModal,
        private presentationUtils: PresentationUtilsService
    ) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.productId = params.get('id-product');
            this.presentationId = params.get('id-pre');
            const navigation = window.history.state;
            console.log('navigation', navigation);
            this.selectedEmpaque =
                navigation.currentPresentation.empaqueUnidadMedida.idEmpaque;
            if (navigation.currentProduct) {
                this.selectedTypeProduct =
                    navigation.currentProduct.tipoProducto.id;
            }

            this.loadPackaging(this.selectedTypeProduct);

            if (navigation.currentPresentation) {
                this.currentPresentationNav = navigation.currentPresentation;
                this.product = navigation.currentProduct;
                this.selectedEmpaque =
                    this.currentPresentationNav.empaqueUnidadMedida.idEmpaque;
                this.selectedUnity =
                    this.currentPresentationNav.empaqueUnidadMedida.id;
            }
            this.loadEditPresentation();
            this.loadUnitsCurrentMeasurement();
        });
    }

    onChange(event: Event) {
        const target = event.target as HTMLSelectElement;
        const selectedIndex = target.selectedIndex;
        const selectedOption = target.options[selectedIndex];

        if (selectedOption instanceof HTMLOptionElement) {
            this.codigoSeleccionado =
                selectedOption.getAttribute('data-codigo');
        }
    }

    loadPackaging(packageId) {
        if (packageId == '1') {
            this.productTypeName = 'plaguicida';
            console.log('this.productTypeName', this.productTypeName);
            this.loadPackage(this.productTypeName);
        } else if (packageId == '2') {
            this.productTypeName = 'fertilizante';
            this.loadPackage(this.productTypeName);
        } else if (packageId == '3') {
            this.productTypeName = 'coadyuvante';
            this.loadPackage(this.productTypeName);
        } else if (packageId == '4') {
            this.loadPackagingAll();
            this.selectedEmpaque = 5;
            this.quantity = 40;
            this.loadUnitsOfMeasurement();
            this.selectedUnity = 9;
        } else if (packageId == '5') {
            this.productTypeName = 'acondicionadorEnmienda';
            this.loadPackage(this.productTypeName);
        } else {
            this.selectedEmpaque = null;
            this.quantity = null;
            this.selectedUnity = null;
        }
    }

    loadPackagingAll() {
        this.http
            .get<PackageResponseInterface[]>(`${this.apiUrl}empaque`)
            .subscribe(
                (response) => {
                    this.optPackaging = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 2',
                        error
                    );
                }
            );
    }

    loadPackage(productTypeName) {
        this.http
            .get<
                PackageResponseInterface[]
            >(`${this.apiUrl}empaque/${productTypeName}`)
            .subscribe(
                (response) => {
                    this.optPackaging = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 2',
                        error
                    );
                }
            );
    }

    loadEditPresentation() {
        this.http
            .get<Presentacion>(
                `${this.apiUrl}presentacion/` + this.presentationId
            )
            .subscribe(
                (response) => {
                    this.currentPresentation = response;
                    this.quantityHolder = this.currentPresentation.cantidad;
                    this.quantity = this.currentPresentation.cantidad;
                },
                (error) => {
                    console.error(
                        'Error al cargar la presentacion a editar',
                        error
                    );
                }
            );
    }

    isPositiveNumber(value: number): boolean {
        return value > 0;
    }

    async verifyPresentationChanges(
        newCode: string,
        currentCode: string
    ): Promise<boolean> {
        console.log(newCode, currentCode, 'codigo');
        if (newCode === currentCode) {
            const result = await Swal.fire({
                title: 'No se han detectado cambios',
                text: 'Estás a punto de guardar sin haber modificado la presentación. ¿Deseas continuar?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar',
            });
            return !result.isConfirmed;
        }

        const isDuplicate = this.product.presentaciones.find(
            (presentation) => presentation.codigoPresentacion === newCode
        );

        if (isDuplicate) {
            await Swal.fire(
                'Esta presentación ya existe',
                'El código de presentación generado ya está en uso para este producto.',
                'error'
            );
            return true;
        }
        return false;
    }

    async onSubmitEditPresentation() {
        if (!this.isPositiveNumber(this.quantity)) {
            Swal.fire('Error', 'La cantidad debe ser positiva', 'error');
            return;
        }

        if (!this.selectedUnity) {
            Swal.fire(
                'Error',
                'Debe seleccionar una unidad de medida equivalente',
                'error'
            );
            return;
        }

        if (!this.quantity) {
            Swal.fire('Error', 'Debe ingresar una cantidad', 'error');
            return;
        }

        if (this.codigoSeleccionado === undefined) {
            this.codigoSeleccionado =
                this.currentPresentation.codigoPresentacion.slice(-2);
        }

        const selectedEmpaqueObj = this.optPackaging.find(
            (p: any) => p.id == this.selectedEmpaque
        );
        const empaqueCode = selectedEmpaqueObj ? selectedEmpaqueObj.codigo : '';

        this.codeUnitMeasurement =
            this.presentationUtils.calculatePresentationCode(
                empaqueCode,
                this.codigoSeleccionado,
                this.quantity
            );

        const shouldStop = await this.verifyPresentationChanges(
            this.codeUnitMeasurement,
            this.currentPresentation.codigoPresentacion
        );

        if (shouldStop) {
            return;
        }

        const formData = {
            empaqueUnidadMedidaId: this.selectedUnity,
            productoId: this.currentPresentation.productoId,
            cantidad: this.quantity,
            activo: this.currentPresentation.estado,
            codigoPresentacion: this.codeUnitMeasurement,
        };

        try {
            const response = await firstValueFrom(
                this.http.put(
                    `${this.apiUrl}presentacion/${this.currentPresentation.id}`,
                    formData
                )
            );

            await Swal.fire({
                title: '¡Éxito!',
                text: 'La presentación se ha actualizado correctamente',
                icon: 'success',
                confirmButtonText: 'Aceptar',
            });

            this.router.navigate([`${this.productId}/presentaciones`]);
        } catch (error) {
            console.error('Error al actualizar la presentación', error);
            Swal.fire(
                'Error',
                'Ocurrió un error al actualizar la presentación',
                'error'
            );
        }
    }

    onChangeEmpaque() {
        this.selectedUnity = null;
        this.quantity = null;
        this.codigoSeleccionado = '';

        if (this.selectedEmpaque) {
            this.http
                .get<
                    any[]
                >(`${this.apiUrl}unidad-medida/by-empaque/${this.selectedEmpaque}`)
                .subscribe(
                    (response) => {
                        this.optUnitsOfMeasurement = response;
                    },
                    (error) => {
                        console.error(
                            'Error al cargar las unidades de medida:',
                            error
                        );
                        this.optUnitsOfMeasurement = [];
                    }
                );
        } else {
            this.optUnitsOfMeasurement = [];
        }
    }

    padWithZeros(input: number): string {
        const integerPart = Math.trunc(input);
        const integerString = integerPart.toString();

        const targetLength = 5;
        const diff = targetLength - integerString.length;

        let paddedInteger = integerString;
        if (diff > 0) {
            paddedInteger = '0'.repeat(diff) + integerString;
        }

        if (input % 1 !== 0) {
            const decimalString = input
                .toString()
                .substring(integerString.length);
            return paddedInteger + decimalString;
        }

        return paddedInteger;
    }
    loadUnitsOfMeasurement() {
        if (this.selectedEmpaque !== this.lastSelectedEmpaque) {
            this.lastSelectedEmpaque = this.selectedEmpaque;
            this.http
                .get<
                    any[]
                >(`${this.apiUrl}unidad-medida/by-empaque/${this.selectedEmpaque}`)
                .subscribe(
                    (response) => {
                        this.optUnitsOfMeasurement = response;
                        this.selectedUnity = undefined;
                    },
                    (error) => {
                        console.error(
                            'Error al cargar opciones de Dropdown 2',
                            error
                        );
                    }
                );
        }
    }

    loadUnitsCurrentMeasurement() {
        this.http
            .get<
                any[]
            >(`${this.apiUrl}unidad-medida/by-empaque/${this.selectedEmpaque}`)
            .subscribe(
                (response) => {
                    this.optUnitsOfMeasurement = response;
                    this.selectedUnity =
                        this.currentPresentationNav.empaqueUnidadMedida.id;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 2',
                        error
                    );
                }
            );
    }
}
